import {Component, Input} from '@angular/core';
import {
  PublisherAdUnitRequestStatus,
  PublisherAdUnitRequestStatusLabels
} from '../../domain/publisher-ad-unit-request-status.enum';

@Component({
  selector: 'cm-publisher-request-status-circle-plate',
  template: `<span class="status-circle"
                   [ngClass]="{
        'status-circle--green': status === PublisherAdUnitRequestStatus.APPROVED
       , 'status-circle--orange': status === PublisherAdUnitRequestStatus.PENDING
       , 'status-circle--blue': status === PublisherAdUnitRequestStatus.REQUESTED
       , 'status-circle--red': status === PublisherAdUnitRequestStatus.REJECTED}">
       <i class="fas fa-circle"></i>
      </span>
  <span class="status-text">
        {{PublisherAdUnitRequestStatusLabels[status]}}
        <ng-content></ng-content>
      </span>
  `,
  host: {
    'class': 'status-circle-plate'
  }
})
export class PublisherRequestStatusCirclePlateComponent {

  @Input()
  public status: PublisherAdUnitRequestStatus;

  public PublisherAdUnitRequestStatus = PublisherAdUnitRequestStatus;
  public PublisherAdUnitRequestStatusLabels = PublisherAdUnitRequestStatusLabels;

}
